export default "__VITE_ASSET__5c55547d__"